import React from 'react';
import { View } from 'react-native';
import Svg from '@styles/icons/svg';
import { Element } from '@components/frame';

export default ({ scale, C }) => {
  const icons = [
    {
      name: 'gallery',
    },
    {
      name: 'cloud',
    },
    {
      name: 'arrow',
    },
    {
      name: 'more',
    },
    {
      name: 'crop',
    },
    {
      name: 'tag',
    },
    {
      name: 'tagSelected',
    },
    {
      name: 'smartIcon',
      color: 'Other/Light/Logo/Factory',
    },
    {
      name: 'smartFactory',
      color: 'Other/Light/Logo/Factory',
    },
    {
      name: 'chevronRightLight',
    },
    {
      name: 'chevronLeft',
    },
    {
      name: 'burger',
    },
    {
      name: 'selected',
    },
    {
      name: 'unselected',
    },
    {
      name: 'settings',
    },
    {
      name: 'camera',
    },
    {
      name: 'picture',
    },
    {
      name: 'file',
    },
    {
      name: 'squares',
    },
    {
      name: 'plus',
    },
    {
      name: 'starSelected',
    },
    {
      name: 'starUnselected',
    },
    {
      name: 'exclamationCircle',
    },
    {
      name: 'times',
    },
    {
      name: 'backspace',
    },
  ];

  return (
    <Element
      {...{
        config: {
          width: '100%',
          paddingLeft: 10,
          paddingRight: 10,
          position: {
            top: 162,
          },
          flexDirection: 'row',
          flexWrap: 'wrap',
        },
      }}
    >
      {icons.map((i) => (
        <View key={i.name} style={{ width: '20%', justifyContent: 'center' }}>
          <View key={i.name} style={{ width: '95%' }}>
            <Svg icon={i.name} width={scale(70)} height={scale(70)} color={i.color} />
          </View>
        </View>
      ))}
    </Element>
  );
};
